<template>
    <div class="container-fluid" title="ใบเสร็จรับเงินรายการเครดิต">
      <div class="row">
        <div class="col-sm bg-light border py-2">
            <table id="myRcptTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
                <thead class="text-white" style="background:Navy">
                <tr>
                    <th style="width:40px;">ยกเลิก</th>
                    <th style="width:40px;">สถานะ</th>
                    <th style="width:100px;">ชื่อสาขา</th>
                    <th style="width:80px;">เลขที่ใบเสร็จรับเงิน</th>
                    <th style="width:80px;">วันที่</th>
                    <th style="width:180px;">ได้รับเงินจาก</th>
                    <th style="width:250px;">ที่อยู่</th>
                    <th style="width:50px;">สุทธิ</th>
                    <th style="width:60px;">คำสั่ง</th>
                </tr>
                </thead>
                <tbody>
                    <tr v-for="item in dataReceiptlists" :key="item.RcptID">
                        <td class="text-danger"><b> {{ arrCancel[item.Cancel] }}</b></td>
                        <td class="">{{ arrDocStatus[item.Status] }}</td>
                        <td class="text-start">{{ item.BranchName }}</td>
                        <td class="text-start">{{ item.RcptNo }}</td>
                        <td class="text-start">{{ item.DocDate }} {{item.DocTime}}</td>
                        <td class="text-start">{{ item.CustName }}</td>
                        <td class="text-start">{{ item.CustAddr }}</td>
                        <td class="text-end">{{  numeralFormat(item.NetAmt, '0,0[.]00') }}</td>
                        <td  >
                          <button type="button" class="btn btn-primary btn-sm mx-1" v-if="item.Cancel==0"
                            id="Edit" @click="confirmSavePaymentWithSelectedReceipt(item)" title="บันทึกรับชำระเงินด้วยเลขที่ใบเสร็จนี้">บันทึก</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
      </div>
    </div>
    <!-- rowEdit : {{rowEdit}}
<hr>
    dataReceiptlists : {{dataReceiptlists}} -->
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
// import 'jquery/dist/jquery.min.js'
// Datatable Modules
// import 'datatables.net-dt/js/dataTables.dataTables'
// import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  name: 'LabPaid3Payment',
  components: {

  },
  data () {
    return {
      arrCancel: ['', 'C'],
      arrSex: ['', 'ชาย', 'หญิง'],
      arrDocStatus: ['New', 'AP'],
      arrPayType: ['เงินสด', 'เครดิต'],

      ReqClinicID: 0,
      // รายการเลขที่ใบเสร็จรับเงิน
      dataReceiptlists: null
    }
  },
  props: ['rowEdit', 'dateFm', 'dateTo'],
  mounted () {
    this.ReqClinicID = this.rowEdit.ReqClinicID
    // ดึงรายการใบเสร็จของคลินิก
    this.getData()
  },
  methods: {
    backPageAfterSave () {
      // console.log('backPageAfterSave <LabPaid3Payment>..')
      this.$emit('onBackPageAfterSaveEvent')
    },
    confirmSavePaymentWithSelectedReceipt (row) {
      Swal.fire({
        title: 'ใบเสร็จ : ' + row.RcptNo,
        text: 'คุณต้องการที่จะบันทึกการรับชำระเงินด้วยใบเสร็จนี้..ใช่หรือไม่? ',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่! แน่ใจ',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          this.savePaymentWithSelectedReceipt(row)
        }
      })
    },
    checkFieldsHeaderBeforeSave () {
      // if (this.RcptAmt < this.NetAmt) {
      //   this.$refs.RcptAmt.focus()
      //   Swal.fire({ position: 'top-end', icon: 'warning', text: 'จำนวนเงินรับชำระน้อยกว่ายอดต้องชำระ!', showConfirmButton: false, timer: 1500 })
      //   return false
      // }
      return true
    },
    savePaymentWithSelectedReceipt (row) {
      var self = this
      if (this.checkFieldsHeaderBeforeSave()) {
        // แปลงข้อมูลจากฟอร์ม
        // var x = $('#fmPay').serializeArray()
        var formData = { ROID: this.rowEdit.ROID, ReqClinicID: this.ReqClinicID, RcptID: row.RcptID }
        // $.each(x, function (i, field) {
        //   $.extend(formData, { [field.name]: field.value })
        // })
        // Insert/Update by call API
        console.log(formData)
        $.ajax({
          type: 'POST',
          url: this.http_baseurl + 'setdata/ro_credit_paid.php',
          data: { request: JSON.stringify(formData) }
        })
          .done(function (resp) {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'บันทึกข้อมูลเสร็จเรียบร้อย',
              showConfirmButton: false,
              timer: 1500
            }).then(function (result) {
              self.backPageAfterSave()
            })
          })
          .fail(function (resp) {
            console.log(resp)
            Swal.fire({ icon: 'error', text: 'ไม่สามารถบันทึกข้อมูลได้' })
          })
      }
    },
    getData () {
      // -------- Date From -----------
      var d = this.dateFm
      var YYYY = d.getFullYear().toString()
      var MM = ''
      var DD = ''
      if (d.getMonth() + 1 < 10) {
        MM = '0' + (d.getMonth() + 1).toString()
      } else {
        MM = (d.getMonth() + 1).toString()
      }
      if (d.getDate() < 10) {
        DD = '0' + d.getDate().toString()
      } else {
        DD = d.getDate().toString()
      }
      var docDateFm = YYYY + '-' + MM + '-' + DD
      // -------- Date To -----------
      d = this.dateTo
      YYYY = d.getFullYear().toString()
      MM = ''
      DD = ''
      if (d.getMonth() + 1 < 10) {
        MM = '0' + (d.getMonth() + 1).toString()
      } else {
        MM = (d.getMonth() + 1).toString()
      }
      if (d.getDate() < 10) {
        DD = '0' + d.getDate().toString()
      } else {
        DD = d.getDate().toString()
      }
      var docDateTo = YYYY + '-' + MM + '-' + DD
      console.log(this.globalCorpID +
        '&ReqClinicID=' + this.ReqClinicID +
        '&DocDateFm=' + docDateFm + '&DocDateTo=' + docDateTo)

      MyApiClient.get('getdata/receipt_where_reqclinic.php?C1=' + this.globalCorpID +
        '&ReqClinicID=' + this.ReqClinicID +
        '&DocDateFm=' + docDateFm + '&DocDateTo=' + docDateTo)
        .then((resp) => {
          // console.log(resp.data.response)
          this.dataReceiptlists = resp.data.response
          setTimeout(function () { $('#myRcptTable').DataTable() }, 0)
        })
        .catch((err) => {
          console.log(err.response)
        })
    }
  }
}
</script>

<style>

</style>
